<script setup lang="ts">
  import type { TVipTier } from '~/store/vip';

  const props = withDefaults(
    defineProps<{
      tier: TVipTier;
      size?: number;
    }>(),
    { size: 100 },
  );

  const sizePx = computed(() => `${props.size}px`);
</script>

<template>
  <div class="vip-star shrink-0 self-center" :data-tier="tier" :style="{ '--size': sizePx }" />
</template>
